// import useStyles from "../styles";
// import { Grid } from "@mui/material";
// import Modal from "../../../components/Modal";
import { Icon } from "@iconify/react";
import Button from "../../../components/Button";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
// import ExaminationCard from "../../../components/ExaminationCard";
import { useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import TabPanel from "@mui/lab/TabPanel";
import Tabs from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import Table from "../../../components/Table/Table";
import Badge from "../../../components/Badge";
import useWindowSize from "../../../hooks/useWindow";
// import Table from "../../../components/Table/Table";
// import { TableSearch } from "../../../components/Table/TableActions";
import PageTitle from "../../../components/PageTitle";
import { TableSearch } from "../../../components/Table/TableActions";
import { toast } from "react-toastify";
import Modal from "../../../components/Modal";
import Layout from "../../../components/Layout";
// import { Grade, ScoreLevel } from "../../../utils/DropDown";

// --| Dummy Data
const GET_ALL_SCHOOL_EXAMINATION = "/api/v1/school-exams";
const EXAM_CONFIG_ENDPOINT = "/api/v1/examination-configs";
const CLASSES_ENDPOINT = "/api/v1/teacher/classes";

const Examination = () => {
  // const classes = useStyles();
  const navigate = useNavigate();
  const [value, setValue] = useState("1");
  const [searchResult, setSearchResult] = useState([]);
  // const [grademodal, setGradeModal] = useState();
  const [enrolmentresultbyclass, setEnrolmentResultByClass] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [allExamData, setAllExamData] = useState([]);
  const [allExamDataForClass, setAllExamDataForClass] = useState([]);
  const [convertModal, setConvertModal] = useState(false);
  const [currentSelected, setCurrentSelected] = useState({});
  const [preserveQuestionsInBank, setPreserveQuestionsInBank] = useState(false);
  const [classesData, setClassData] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isClassLoading, setIsClassLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState("");
  const [isConverting, setIsConverting] = useState(false);
  const [isPageFetching, setIsPageFetching] = useState(false);
  const [isForClassFetching, setIsForClassFetching] = useState([]);
  const preserveCheckboxStatus = String(currentSelected?.status ?? "").trim().toLowerCase();
  const shouldShowPreserveQuestionsCheckbox = preserveCheckboxStatus !== "" && preserveCheckboxStatus !== "empty";

  const width = useWindowSize();
  const mobile = width < 600;

  /**
 * Fetches all enrolment examination data from the server
 * @async
 * @function getAllEnrollment
 */
  const getAllEnrollment = () => {
    setIsPageFetching(true);
    httprequest.get(GET_ALL_SCHOOL_EXAMINATION).then((res) => {
      setIsPageFetching(false);
      setAllExamData(res?.data?.data);
      setSearchResult(res?.data?.data);
    }).catch((err) => {
      setIsPageFetching(false);
      toast.error(err?.response?.data);
    });
  };

  /**
 * Fetches enrolment examination data for a specific class
 * @async
 * @function getAllEnrollmentExamByClass
 * @param {string} classId - The ID of the class to filter by
 */
  const getAllEnrollmentExamByClass = (classId) => {
    setIsForClassFetching(true);
    httprequest.get(`${GET_ALL_SCHOOL_EXAMINATION}?class_id=${classId}`).then((res) => {
      setIsForClassFetching(false);
      setAllExamDataForClass(res?.data?.data);
      setEnrolmentResultByClass(res?.data?.data);
    }).catch((err) => {
      setIsForClassFetching(false);
      toast.error(err?.response?.data);
    });
  };

  /**
 * Handles tab change event and fetches class-specific data when needed
 * @function handleChange
 * @param {Event} event - The event object
 * @param {string} newValue - The new tab value (class ID or "1" for all)
 */
  const handleChange = (event, newValue) => {
    setValue(newValue);

    // Fetch data only if a specific class tab is selected
    if (newValue !== "1") {
      getAllEnrollmentExamByClass(newValue);
    }
  };

  /**
 * Fetches all class data from the server
 * @async
 * @function getAllClasses
 */
  const getAllClasses = () => {
    setIsClassLoading(true);
    httprequest.get(CLASSES_ENDPOINT).then((res) => {
      // const physicalClasses = res?.data?.data?.filter((data) => data?.class_type === "physical");
      setClassData(res?.data?.data);
      setIsClassLoading(false);
    }).catch((err) => {
      toast.error(err?.response?.data);
      setIsClassLoading(false);
    });
  };

  /**
 * Toggles the delete confirmation modal and sets the current selected exam
 * @function handleDeleteModal
 * @param {Object} row - The exam row data to be deleted
 */
  const handleDeleteModal = (row) => {
    setCurrentSelected(row);
    setPreserveQuestionsInBank(false);
    setDeleteModal(!deleteModal);
  };

  /**
 * Toggles the convert confirmation modal and sets the current selected exam
 * @function handleConvertModal
 * @param {Object} row - The exam row data to be converted
 */
  const handleConvertModal = (row) => {
    setCurrentSelected(row);
    setConvertModal(!convertModal);
  };

  /**
 * Closes the delete confirmation modal
 * @function handleCloseDeleteModal
 */
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setPreserveQuestionsInBank(false);
  };

  /**
 * Closes the convert confirmation modal
 * @function handleCloseConvertExam
 */
  const handleCloseConvertExam = () => {
    setConvertModal(false);
  };

  /**
 * Deletes the currently selected exam
 * @async
 * @function handleDeleteAnExam
 */
  const handleDeleteAnExam = () => {
    setIsDeleting(true);
    httprequest.delete(`${EXAM_CONFIG_ENDPOINT}/${currentSelected?.id}`, {
      data: {
        preserve_questions_in_bank: !!preserveQuestionsInBank
      }
    }).then(() => {
      setIsDeleting(false);
      toast.success("Exam Deleted Succesfully");
      getAllEnrollment();
      handleCloseDeleteModal();
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
 * Converts the currently selected exam
 * @async
 * @function handleConvertExam
 */
  const handleConvertExam = () => {
    setIsConverting(true);
    httprequest.post(`${GET_ALL_SCHOOL_EXAMINATION}/${currentSelected?.id}/convert`).then((res) => {
      setIsConverting(false);
      toast.success(res?.data?.message);
      getAllEnrollment();
      handleCloseConvertExam();
    }).catch((err) => {
      setIsConverting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
   * Initialize data on component mount
   */
  useEffect(() => {
    getAllEnrollment();
    getAllClasses();
    getAllEnrollmentExamByClass();
  }, []);
  // const handleGradeModal = () => {
  //   setGradeModal(!grademodal);
  // };

  // const [searchResult, setSearchResult] = useState([]);

  /**
 * Array of column definitions for the data table
 * @type {Array<Object>}
 * @property {string} name - Column header name
 * @property {function} selector - Function to render cell content
 * @property {boolean} [center] - Whether to center-align content
 * @property {boolean} [sortable] - Whether column is sortable
 * @property {function} [cell] - Custom cell renderer function
 */
  const columns = [
    {
      name: "Subject",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Subject</p>}
          {row?.subject?.name || "--/--"}
        </>
      )
    },
    {
      name: "Classes",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Classes</p>}
          {row?.classes?.map((clss) => (
            <span className="class_div" key={clss?.id}>
              {clss?.name}
            </span>
          )) || "--/--"}
        </>
      )
    },
    {
      name: "Created By",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Created By</p>}
          {`${row?.created_by?.last_name || "nil"} ${row?.created_by?.first_name || "nil"}` || "--/--"}
        </>
      )
    },
    {
      name: "Duration (in mins)",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Duration (in mins)</p>}
          {row?.duration || "--/--"}
        </>
      )
    },
    {
      name: "Date Updated",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Date Updated</p>}
          {row?.updated_at ? row.updated_at.substring(0, 10) : "--/--"}
        </>
      )
    },
    {
      name: "Status",
      center: true,
      cell: (row) => <Badge status={row?.status} />
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <Link to={`/school-examination/examination-details/${row?.id}`}>
            <button className="table-action-icon">
              <Icon icon="fluent:eye-16-regular" />
            </button>
          </Link>
          <button
            className="table-action-icon"
            onClick={() => navigate(`/school-examination/examination-details/${row?.id}?editConfig`)}
          >
            <Icon icon="heroicons:pencil-square-solid" />
          </button>
          <button
            onClick={() => handleConvertModal(row)}
            className="table-action-icon"
          >
            <Icon icon="ion:reload-circle-sharp" width="20" height="20" />
          </button>
          <button className="table-action-icon delete-icon" onClick={() => handleDeleteModal(row)}>
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];
  /**
 * Filters class-specific exams by status
 * @function handleFilterClassChange
 * @param {Event} e - The change event from the filter dropdown
 */
  const handleFilterClassChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Filter assignments based on selected status in a class
    const filteredByStatus = value === "published"
      ? enrolmentresultbyclass?.filter((data) => data?.status === "published")
      : value === "draft"
        ? enrolmentresultbyclass?.filter((data) => data?.status === "draft")
        : enrolmentresultbyclass;

    setAllExamDataForClass(filteredByStatus);
  };

  /**
 * Filters all exams by status
 * @function handleFilterChange
 * @param {Event} e - The change event from the filter dropdown
 */
  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Filter assignments based on selected status
    const filteredByStatus = value === "published"
      ? allExamData?.filter((data) => data?.status === "published")
      : value === "draft"
        ? allExamData?.filter((data) => data?.status === "draft")
        : allExamData;
    setSearchResult(filteredByStatus);
  };

  /**
 * Searches all enrolment exams by subject, class, or creator name
 * @function handleSearchAllEnrolmentExam
 * @param {Event} e - The input change event
 */
  const handleSearchAllEnrolmentExam = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");

    const filteredByStatus = filterStatus
      ? allExamData.filter((data) => data.status.toLowerCase() === filterStatus.toLowerCase())
      : allExamData;
    // --| Filter data by partial match onchange in the search input box
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.subject?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                data?.class?.name?.toLowerCase()
                  .includes(word.toLowerCase()) ||
                data?.created_by?.name?.toLowerCase()
                  .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  /**
 * Searches class-specific exams by subject, class, or creator name
 * @function handleSearchAssignmentByClass
 * @param {Event} e - The input change event
 */
  const handleSearchAssignmentByClass = (e) => {
    const { value } = e.target;
    const valArray = value.split(" ");

    const filteredByStatus = filterStatus
      ? enrolmentresultbyclass.filter((data) => data.status.toLowerCase() === filterStatus.toLowerCase())
      : enrolmentresultbyclass;

    // Filter by partial match in subject, class, and creator's name
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.subject?.name?.toLowerCase().includes(word.toLowerCase()) ||
                data?.classes?.name?.toLowerCase().includes(word.toLowerCase()) ||
                data?.created_by?.name?.toLowerCase().includes(word.toLowerCase())
    ));

    setAllExamDataForClass(result);
  };

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Examination"
            subtitle="View all the examination"
            button={
              <div className="flex gap-10">
                <Button onClick={() => navigate("/school-examination/create-examination")} variant="primary" buttonSize="fluid" color="btndefault" buttonName="Create Examination" />
              </div>
            }
          />
          <div className="page-content">
            <TabContext value={value}>
              <div className="tablist-container padding-left-16">
                <Tabs
                  className="overide-tablist"
                  onChange={handleChange}
                  aria-label=""
                >
                  <Tab label="All Examination" value="1" />
                  {isClassLoading ? (
                    <div className="container-left">
                      <Icon icon="eos-icons:three-dots-loading" width="50" height="50" />
                    </div>
                  ) : (
                    classesData?.map((data, i) => (
                      <Tab key={i} value={data?.class?.id} label={data?.class?.name} />
                    ))
                  )}
                </Tabs>
              </div>
              <TabPanel value="1" className="tabpanel-overide">
                <Table data={searchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
                  <div className="action_div">
                    <TableSearch placeholder="Search here..." searchTableFunc={handleSearchAllEnrolmentExam} />
                    <div className="text-center gap-10 cursor-pointer">
                      {isPageFetching ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" style={{ color: "#858585" }} />
                        : <Icon onClick={getAllEnrollment} icon="hugeicons:reload" width="20" height="20" style={{ color: "#858585" }} />}
                      <div>
                        <SelectGroup
                          children={
                            <select name="type" onChange={handleFilterChange}>
                              <option value="">-- Sort By--</option>
                              <option value="published">Published</option>
                              <option value="draft">Draft</option>
                              {/* <option value="withdrawn">Withdrawn</option> */}
                            </select>
                          }
                        />
                      </div>
                    </div>
                  </div>
                }
                />
              </TabPanel>
              {classesData?.map((data, i) => {
                return (
                  <TabPanel className="tabpanel-overide" key={i} value={data?.class?.id}>
                    <Table
                      data={allExamDataForClass}
                      columns={columns}
                      subHeader={true}
                      pagination
                      subHeaderComponent={
                        <div className="action_div">
                          <TableSearch placeholder="Search here..." searchTableFunc={handleSearchAssignmentByClass} />
                          <div className="text-center gap-10 cursor-pointer">
                            {isForClassFetching ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" style={{ color: "#858585" }} />
                              : <Icon onClick={() => getAllEnrollmentExamByClass(value)} icon="hugeicons:reload" width="20" height="20" style={{ color: "#858585" }} />}
                            <div>
                              <SelectGroup
                                children={
                                  <select name="type" onChange={handleFilterClassChange}>
                                    <option value="">-- Sort By--</option>
                                    <option value="published">Published</option>
                                    <option value="draft">Draft</option>
                                    {/* <option value="withdrawn">Withdrawn</option> */}
                                  </select>
                                }
                              />
                            </div>
                          </div>
                        </div>
                      }
                    />
                  </TabPanel>
                );
              })}
            </TabContext>
          </div>
          <Modal
            title="Delete School Examination"
            subtitle={
              <div>Are you sure you want to delete
                <span className="modal-name-highlight">{" "}
                  {currentSelected?.subject?.name ?? "this subject"} for{" "}
                  {currentSelected?.classes?.map((clss, index) => (
                    <span className="" key={clss?.id}>
                      {clss?.name}
                      {index < currentSelected.classes.length - 1 ? ", " : ""}
                    </span>
                  )) || " these classes"}.
                </span>{" "}
             Implication is that this Examination will be deleted completely
              </div>}
            modalContent={
              <>
                {shouldShowPreserveQuestionsCheckbox && (
                  <div style={{ marginTop: 8 }}>
                    <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                      <input
                        type="checkbox"
                        checked={preserveQuestionsInBank}
                        onChange={(e) => setPreserveQuestionsInBank(e.target.checked)}
                      />
                      Preserve questions on this Examination and add them to bank.
                    </label>
                  </div>
                )}
              </>
            }
            modalFooter={
              <>
                <Button variant="danger" buttonName="Delete Examination" buttonSize="full" color="btndefault" onClick={handleDeleteAnExam} isLoading={isDeleting} />
              </>
            }
            isopen={deleteModal}
            closeModal={handleCloseDeleteModal}
          />
          {/* Convert MOdal */}
          <Modal
            title="Convert Examination to Enrolment Examination"
            subtitle={
              <div>
      Are you sure you want to convert
                <span className="modal-name-highlight">{" "}
                  {currentSelected?.subject?.name ?? "this subject"} for{" "}
                  {currentSelected?.classes?.map((clss, index) => (
                    <span className="" key={clss?.id}>
                      {clss?.name}
                      {index < currentSelected.classes.length - 1 ? ", " : ""}
                    </span>
                  )) || " these classes"}
                </span>{" "}
      to an Enrolment Examination?
              </div>
            }
            modalContent={<></>}
            modalFooter={
              <>
                <Button
                  variant="primary"
                  buttonName="Convert Examination"
                  buttonSize="full"
                  color="btndefault"
                  onClick={handleConvertExam}
                  isLoading={isConverting}
                />
              </>
            }
            isopen={convertModal}
            closeModal={handleCloseConvertExam}
          />
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default Examination;
